<template>
  <v-autocomplete
    v-model="localValue"
    hide-details
    :hint="`${localValue}`"
    label="Select Athlete Name"
    :items="getAthletes"
    item-value="athleteId"
    :item-text="athleteLongName"
    dense
    :rules="requiredRule"
    outlined
    sort
    clearable
  >
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
import { validation } from "../../mixins/validationMixin";

export default {
  props: {
    parentValue: {
      type: Number,
      default: () => "",
      required: true
    },
    mode: {
      type: String,
      default: () => "",
      required: false
    }
  },
  mixins: [validation],
  model: {
    prop: "parentValue",
    event: "parentValueChange"
  },
  data() {
    return {
      athleteId: null
    };
  },
  computed: {
    ...mapGetters([
      "loading",
      "athleteList",
      "resultsList",
      "athleteOfficialResults"
    ]),
    getAthletes: function() {
      if (
        this.athleteList.edges &&
        this.resultsList.length > 0 &&
        this.mode !== "PERF"
      ) {
        return Array.from(
          new Set(this.resultsList.map(item => item.athleteId))
        ).map(athleteId => {
          let athlete = this.athleteList.edges.find(
            i => +i.node.athleteId === +athleteId
          );
          return athlete
            ? {
                athleteId: athleteId,
                firstName: athlete ? athlete.node.firstName : "No data",
                lastName: athlete
                  ? athlete.node.lastName
                  : "No data",
                birthDate: athlete ? athlete.node.birthDate : "No data"
                // .node.meetName.replace("Meet Results-", "")
              }
            : "";
        });
      } else if (
        this.athleteList.edges &&
        this.athleteOfficialResults.length > 0 &&
        this.mode == "PERF"
      ) {
        return Array.from(
          new Set(this.athleteOfficialResults.map(item => item.node.athleteId))
        ).map(athleteId => {
          let athlete = this.athleteList.edges.find(
            i => +i.node.athleteId === +athleteId
          );
          return athlete
            ? {
                athleteId: athleteId,
                firstName: athlete ? athlete.node.firstName : "No data",
                lastName: athlete
                  ? athlete.node.lastName
                  : "No data",
                birthDate: athlete ? athlete.node.birthDate : "No data"
                // .node.meetName.replace("Meet Results-", "")
              }
            : "";
        });
      } else {
        return [];
      }
    },
    localValue: {
      get: function() {
        return this.parentValue;
      },
      set: function(value) {
        this.$emit("parentValueChange", value);
      }
    }
  },
  created() {
    this.handleGetAthleteList();
    // if (!(Object.entries(this.$route.query).length === 0)) {
    //   const { athleteId } = this.$route.query;
    //   //assign to current instance variables
    //   this.athleteId = athleteId;
    // }
  },
  methods: {
    athleteLongName: item =>
      // item.athleteId +
      // " " +
      item.firstName +
      " " +
      item.lastName +
      " (" +
      item.birthDate +
      ")",
    handleGetAthleteList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allAthlete", {
        clubId: this.$route.params.club
      });
    }

    // Define the method that emits data to the parent as the first parameter to `$emit()`.
    // This is referenced in the <template> call in the parent. The second parameter is the payload.
    // emitToParent (eevnt) {

    //   this.$emit('childToParent', this.childMessage)
    // }
  }
  // watch: {
  //   athleteId: function() {
  //     this.$emit("change-athlete", this.athleteId);
  //   }
  // }
};
</script>
